import { money } from "./money";

/**
 * The landing page's one way in: a WhatsApp chat with the ChatNutri team. Self-signup is v2
 * (docs/13-roadmap.md), so every call to action opens this conversation, with a first message
 * that already says what the visitor wants.
 *
 * Each call to action has its own first message on purpose: the chat lands in our own ChatNutri
 * inbox, and the wording says which part of the page convinced the person. No analytics tool.
 *
 * TODO(Alex): the team's real number, digits only with the country code (55…). Until then this is
 * a placeholder and the buttons open a chat with nobody.
 */
export const SALES_WHATSAPP = "5500000000000";

/**
 * The monthly price the offer starts at, in cents. TODO(Alex): the value. While it is null the
 * page shows no anchor at all, rather than a placeholder price somebody could screenshot.
 */
export const PRICE_FROM: number | null = null;

/** "A partir de R$ 197/mês", or null when there is no anchor yet. */
export function priceLabel(cents: number | null = PRICE_FROM): string | null {
  return cents === null ? null : `A partir de ${money(cents)}/mês`;
}

/** `https://wa.me/<number>?text=…`, with the text encoded the way WhatsApp reads it. */
export function wa(text: string, number = SALES_WHATSAPP): string {
  return `https://wa.me/${number.replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;
}

export const SALES_MESSAGES = {
  nav: "Oi! Vi o site do ChatNutri e quero conhecer.",
  hero: "Oi! Quero ver o ChatNutri funcionando.",
  journey: "Oi! Quero entender como o ChatNutri organiza meus leads e pacientes.",
  control: "Oi! Quero ver como o assistente do ChatNutri escreve as respostas.",
  offer: "Oi! Quero uma proposta do ChatNutri. Somos __ pessoa(s) atendendo, com __ número(s) de WhatsApp e cerca de __ conversas por mês.",
  closing: "Oi! Quero ver o ChatNutri com as minhas conversas.",
  sticky: "Oi! Vim pelo site do ChatNutri e quero saber mais.",
  login: "Oi! Ainda não uso o ChatNutri e queria conhecer.",
} as const;
